import { cn } from "@/lib/cn";
import type { ButtonHTMLAttributes } from "react";

type Variant = "default" | "brand" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md" | "lg";

const variants: Record<Variant, string> = {
  default: "bg-foreground text-accent hover:opacity-90 hover:shadow-[var(--shadow-pop)]",
  brand: "bg-accent text-accent-foreground hover:bg-accent-hover hover:shadow-[0_8px_24px_rgba(159,232,112,0.4)]",
  secondary: "bg-canvas text-foreground hover:bg-canvas-hover",
  ghost: "text-muted hover:bg-canvas hover:text-foreground",
  danger: "bg-red-50 text-red-600 hover:bg-red-100",
};

const sizes: Record<Size, string> = {
  sm: "h-9 px-4 text-sm",
  md: "h-11 px-5 text-sm",
  lg: "h-14 px-8 text-base",
};

export function Button({
  className,
  variant = "default",
  size = "md",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: Size }) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-1.5 rounded-full font-bold transition-[background-color,color,opacity,transform,box-shadow] duration-200 ease-[var(--ease-out-expo)] hover:-translate-y-px active:translate-y-0 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    />
  );
}
